import { createContext, useState, useEffect } from "react";
import homePageAPI from "../api/homePageApi";

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await homePageAPI.fetchCategories();
      if (res.code === 200) {
        setCategories(res.data);
      }
    } catch (err) {
      console.log("No Data");
    }
  };

  return (
    <CategoryContext.Provider value={{ categories }}>
      {children}
    </CategoryContext.Provider>
  );
};
